<template>
  <div id="publishing-editorial-board-detail">
    <ipub-model width="750px"
                :visable="isVisable"
                :showHeader="false"
                :showFooter="false"
                @cancel="cancel">
      <div class="flex editorial-board-detail-avatar mar-b-20">
        <div class="editorial-board-detail-avatar-img">
          <img :src="`${domain}/${inputData.icon||'imageFile/icon.svg'}`"
               alt="">
        </div>
        <div class=" mar-l-20"
             style="width: calc(100% - 160px)">
          <div class="ipub-h2 mar-b-10">Dr. {{inputData.firstName}} {{inputData.lastName}}</div>
          <div class="ipub-p2 mar-b-10 flex">
            <div class="fw-bd"
                 style="width:80px">Email</div>
            <div class="font-color"
                 style="width:calc(100% - 90px)">{{inputData.email}}</div>
          </div>
          <div class="flex mar-b-10 ipub-p2">
            <div class="fw-bd"
                 style="width:80px">Identity</div>
            <div class="font-color"
                 style="width:calc(100% - 90px)">{{editorialBoard[inputData.identityCode]}}</div>
          </div>
          <div class="flex ipub-p2 mar-b-10">
            <div class="fw-bd"
                 style="width:80px">Hierarchy</div>
            <div class="font-color"
                 style="width:calc(100% - 90px)">{{inputData.sort || 0}}</div>
          </div>
        </div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:150px">Affiliations</div>
        <div class="mar-l-10"
             style="width:calc(100% - 160px)">{{inputData.affiliation || '--'}}</div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:150px">H-index</div>
        <div class="mar-l-10"
             style="width:calc(100% - 160px)">{{inputData.hindex || '--'}}</div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:150px">H-index URL</div>
        <div class="mar-l-10"
             style="width:calc(100% - 160px)">
          <a v-if="inputData.hindexUrl"
             target="_blank"
             :href="inputData.hindexUrl"
             class="link-color">{{inputData.hindexUrl}}</a>
          <template v-else>--</template>
        </div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:150px">ORCID</div>
        <div class="mar-l-10"
             style="width:calc(100% - 160px)">{{inputData.orcid || '--'}}</div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:150px">ResearchGate</div>
        <div class="mar-l-10"
             style="width:calc(100% - 160px)">{{inputData.researchGate || '--'}}</div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:150px">Website</div>
        <div class="mar-l-10"
             style="width:calc(100% - 160px)">
          <a v-if="inputData.website"
             :href="inputData.website"
             target="_blank"
             class="link-color">{{inputData.website}}</a>
          <template v-else>--</template>
        </div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:150px">Interests</div>
        <div class="mar-l-10"
             style="width:calc(100% - 160px)"
             v-html="inputData.interest"></div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:150px">Reviewed Journal</div>
        <div class="mar-l-10"
             style="width:calc(100% - 160px)">{{inputData.reviewJournal || '--'}}</div>
      </div>
      <div class="flex mar-b-10 ipub-p2">
        <div class="fw-bd"
             style="width:150px">CV</div>
        <div class="mar-l-10"
             style="width:calc(100% - 160px)">
          <ipub-label v-if="inputData.cv"
                      type="link"
                      size="small">
            <a class="ipub-c-p link-color"
               @click="goToPage(`${domain}/${inputData.cv}`, inputData.cvName)">
              {{inputData.cvName || '--'}}
              <ipub-icon type="iconDownload1" />
            </a>
          </ipub-label>
          <font v-else>--</font>
        </div>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import help from '@/utils/help'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      editorialBoard: 'getEditorialBoard'
    })
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },

    goToPage (val, name) {
      help.download(val, name)
    },
  }
}
</script>

<style lang="scss" scoped>
#publishing-editorial-board-detail {
  .editorial-board-detail {
    &-avatar {
      width: 100%;
      &-img {
        border-radius: 4px;
        height: 140px;
        width: 125px;
        font-size: 170px;
        color: $line_color;
        background: $font_color;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
